class UpgradeTeaserController {
  constructor($scope, $uibModalInstance, $analytics) {
    this.$scope         = $scope
    this.$analytics     = $analytics
    this.$uibModalInstance = $uibModalInstance
  }

  get urls() {
    return this.$uibModalInstance.config.urls
  }

  get price() {
    return this.$uibModalInstance.config.price
  }

  get summaries() {
    return this.$uibModalInstance.config.summaries
  }

  get headers() {
    return this.$uibModalInstance.config.headers
  }
 
  dismissAndTrack(eventName) {
    this.track(eventName)
    this.$uibModalInstance.dismiss(null)
  }

  track(action) {
    this.$analytics.eventTrack(
      'Modal Interaction',
      {action: action}
    )
  }
}

UpgradeTeaserController.$inject = ['$scope', '$uibModalInstance', '$analytics']

export default UpgradeTeaserController